export const emails_gapi = state => state.emails.gapi
export const emails_get_message = state => state.emails.message
export const emails_get_messages = state => state.emails.messages
export const emails_get_pagination = state => state.emails.pagination
export const emails_get_profile = state => state.emails.profile
export const emails_is_signed_in = state => state.emails.is_signed_in
export const emails_label = state => state.emails.label
export const emails_labels = state => state.emails.labels
export const emails_query = state => state.emails.query
